import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ArrowLeftIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="m1.5 8 7.2 7.2 1.5-1.4L5.4 9h10V7h-10l4.8-4.8L8.7.8 1.5 8Z"
        data-testid="icon-arrowLeft"
        fill={customColour}
        className={styles[className]}
      />
    </Icon>
  )
}
